query GetActivities($entityId: ID!, $status: Int, $limit: Int) {
    activities(entityId: $entityId, status: $status, limit: $limit) {
        id
        name
        startTime
        endTime
        activityType {
            id
            name
        }
        participants {
            id
            name
        }
        htmlUrl
        showTranscribeLoggingFlow
        externalMeetingServiceType
        isPrivate
    }
}
